// @ts-nocheck
import {Column} from 'react-table'
import {CustomHeader} from './CustomHeader'
import {SelectionHeader} from './SelectionHeader'
import {customersReports, User} from '../../core/_models'
import {CustonCell} from './CustonCell'
import {formatMask} from '../../../../../../utils/formatMonetaryToBr'
import {formatDate, formatDateTime} from '../../../../../../utils/dayJs/format'
import {phoneMask} from '../../../../../../utils/phoneMask'
import {cpfMask} from '../../../../../../utils/cpfMask'
import {formatarDataPtBr} from '../../../../../../utils/dateMask'
import {KTIcon} from '../../../../../../_metronic/helpers'
import {downloadFilePDF} from '../../core/_requests'
import {TooltipWrapper} from '../../../../../../components/Tooltip'
import {InvoiceModal} from '../../components/modal/InvoiceModal'

const FranchiseInvoicesColumns = () => [
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Data Vencimento' className='min-w-125px' />
    ),
    id: 'dueDate',
    Cell: ({...props}) => (
      <CustonCell value={formatarDataPtBr(props.data[props.row.index].dueDate)} />
    ),
  },

  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='código de referência' className='min-w-125px' />
    ),
    id: 'referenceCode',
    Cell: ({...props}) => <CustonCell value={props.data[props.row.index].referenceCode} />,
  },

  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='período de referência' className='min-w-125px' />
    ),
    id: 'referenceStart',
    Cell: ({...props}) => (
      <CustonCell
        value={`${formatDate(props.data[props.row.index].referenceStart)} - ${formatDate(
          props.data[props.row.index].referenceEnd
        )}`}
      />
    ),
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Total Requisições' className='min-w-50px' />
    ),
    id: 'totalRequests',
    Cell: ({...props}) => <CustonCell value={props.data[props.row.index].totalRequests} />,
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='Valor' className='min-w-50px' />,
    id: 'totalAmount',
    Cell: ({...props}) => (
      <CustonCell value={formatMask(props.data[props.row.index].totalAmount)} />
    ),
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='Status' className='min-w-50px' />,
    id: 'status',
    Cell: ({...props}) => (
      <CustonCell
        value={
          <span
            className='d-inline-flex align-items-center fw-semibold px-3 py-1 rounded'
            style={{
              fontSize: '12px',
              cursor: 'default',
              backgroundColor: `${props.data[props.row.index].status?.color ?? '#cccccc'}'20`,
              color: props.data[props.row.index].status?.color ?? '#cccccc',
              border: `1px solid ${props.data[props.row.index].status?.color ?? '#cccccc'}`,
            }}
          >
            {props.data[props.row.index]?.status?.name}
          </span>
        }
      />
    ),
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='Data PGTO' className='min-w-50px' />,
    id: 'paidAt',
    Cell: ({...props}) => (
      <CustonCell
        value={
          props.data[props.row.index]?.paidAt ? formatDate(props.data[props.row.index].paidAt) : ''
        }
      />
    ),
  },
]

export {FranchiseInvoicesColumns}
